import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import style from '../../../styles/styles';
import styles from './AdminPage.css';
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import AdminFull from "../../../components/admin/AdminFull/AdminFull";
import {fetchAdmin, resetAdmin, deleteAdmin} from '../../../store/admins/actions'
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import AdminService from '../../../services/admin';
import {SUPER_ADMIN} from '../../../services/admin';
import {Link} from "react-router-dom";
import {grey400} from 'material-ui/styles/colors';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import {Dialog, FlatButton} from "material-ui";
import withTranslation from "../../../hoc/withTranslation";
import {EDIT_ADMIN_PAGE, HOMEPAGE} from "../../../constants/routes";

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400} />
    </IconButton>
);

export class AdminPage extends React.Component {

    static propTypes = {
        admin: PropTypes.object
    };

    static defaultProps = {
        loading: true,
        admin: null
    };

    state = {
        apps: [],
        openRemoveAdmin: false
    };

    componentWillMount() {
        this.update(this.props);
    }

    componentWillUnmount() {
        resetAdmin();
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            if (!nextProps.app) { // App has been deleted
                this.props.history.push(HOMEPAGE);
            }
        }

        if (nextProps !== this.props) {
            this.update(nextProps);
        }
    }

    update(props) {
        if (!props.admin && !props.appError) {
            this.fetchAdmin();
        }
    }

    // Fetch

    fetchAdmin() {
        if (this.props.match) {
            const id = this.props.match.params.adminId;
            if (id) {
                this.props.fetchAdmin(id)
            }
        }
    }

    // Delete admin

    handleDeleteAdmin = (admin) => {
        this.setState({
            openRemoveAdmin: true
        });
    };

    handleCloseAdmin = () => {
        this.setState({
            openRemoveAdmin: false
        });
    };

    deleteAdmin = () => {
        this.props.deleteAdmin(this.props.admin);
    };

    // Render

    renderDeleteAdminDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseAdmin}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteAdmin}
            />
        ];

        return (
            <Dialog
                title={this.props.t('account_page.remove_admin')}
                actions={actions}
                modal={false}
                open={this.state.openRemoveAdmin}
                onRequestClose={this.handleCloseAdmin}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                <p>
                    <div dangerouslySetInnerHTML={{
                        __html:
                            this.props.t('account_page.remove_admin_confirmation', {
                                firstname: this.props.admin.firstname,
                                lastname: this.props.admin.lastname,
                                username: this.props.admin.username
                            })
                    }} />
                </p>
                }
            </Dialog>
        );
    }

    render() {
        if (this.props.adminError) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.admin) {
            return <Loading paper={false} />;
        } else {
            let menu;
            if (AdminService.isAuthorized(SUPER_ADMIN, this.props.user)) {
                menu = (
                    <IconMenu
                        style={styles.buttons}
                        listStyle={style.list}
                        iconButtonElement={iconButtonElement}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}>
                        <Link to={EDIT_ADMIN_PAGE.replace(':adminId', this.props.admin.id)}>
                            <MenuItem>
                                {this.props.t('generic.edit')}
                            </MenuItem>
                        </Link>
                        <MenuItem onClick={this.handleDeleteAdmin}>
                            {this.props.t('generic.remove')}
                        </MenuItem>
                    </IconMenu>
                );
            } else {
                menu = null;
            }
            return (
                <div>
                    {this.renderDeleteAdminDialog()}

                    <h3 style={style.navigation}>{this.props.t('generic.admin')} / {this.props.t('generic.detail')} - {this.props.admin.firstname} {this.props.admin.lastname} ({this.props.admin.email})</h3>
                    {menu}
                    <AdminFull apps={this.props.apps} admin={this.props.admin} />
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.admins.pending && state.apps.pending,
        adminError: state.admins.error,
        user: state.auth.content,
        sending: state.admins.sending
    };

    if (state.admins.currentAdmin && state.apps.content) {
        props.admin = state.admins.currentAdmin;
        props.apps = state.apps.content.filter((app) => {
            return app.admins.find((admin) => {
                return admin.id === props.admin.id
            }) !== undefined;
        });
    }
    return props;
}

export default connect(mapStateToProps, {fetchAdmin, deleteAdmin})(withTranslation(AdminPage));



// WEBPACK FOOTER //
// src/containers/admin/AdminPage/AdminPage.js